import request from '@/utils/request'

let RotationApi = {

  /*轮播管理*/
  rotationList(data, errorback) {
    return request._get('/shop/plus.banner/index', data, errorback);
  },
  rotationDetail(data, errorback) {
    return request._get('/shop/plus.banner/edit', data, errorback);
  },
  /*轮播添加*/
  rotationAdd(data, errorback) {
    return request._post('/shop/plus.banner/add', data, errorback);
  },
  /*轮播删除*/
  rotationDel(data, errorback) {
    return request._post('/shop/plus.banner/del', data, errorback);
  },
  /*轮播修改*/
  rotationEdit(data, errorback) {
    return request._post('/shop/plus.banner/edit', data, errorback);
  },

}

export default RotationApi;



// WEBPACK FOOTER //
// ./src/api/rotation.js